import {Account, useUpdateAccountMutation} from 'api';
import React, {useEffect, useRef, useState} from 'react';

interface Props {
  account: Account;
}

export default ({account}: Props) => {
  const [updateAccount] = useUpdateAccountMutation({
    refetchQueries: ['activitiesByProspectPool'],
  });
  const [telephoneNumber, setTelephoneNumber] = useState(
    account.telephoneNumber,
  );
  const ref = useRef(null);

  useEffect(() => {
    ref.current.value = account.telephoneNumber;
  }, [account]);

  return (
    <input
      defaultValue={telephoneNumber}
      className="w-60 h-7 rounded hover:border hover:border-border focus:border focus:border-border"
      onChange={(e) => setTelephoneNumber(e.target.value)}
      onBlur={(e) =>
        updateAccount({
          variables: {
            id: account.id,
            attributes: {
              telephoneNumber: e.target.value,
            },
          },
        })
      }
      ref={ref}
    />
  );
};
